import type { FooterColumn, SiteConfig, SiteLink } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Softly',
    description: "Softly is one gentle, fragrance-free balm for rough hands, dry knees, elbows and every dry spot in between.",
    url: getOrigin(),
    domain: 'softly.studio',
    email: 'hello@softly.studio',
    // Swap these for the brand's own profile links.
    links: {
        facebook: 'https://www.facebook.com',
        x: 'https://x.com',
        instagram: 'https://www.instagram.com'
    }
}

export const COPYRIGHT_YEAR = 2026

// In-page targets on the home page. "hands" and "ingredients" are cards in the Daily care carousel,
// "stories" opens the Rescue carousel. Every one of them lives inside the #uses section.
export const USE_TARGETS = ['hands', 'ingredients', 'stories'] as const

// Where every "Shop the balm" button goes. One place to change when the shop opens.
export const SHOP_HREF = '/shop'

// Choices in the contact form on /about#contact. The API only accepts these, and each message keeps its topic in the CMS.
export const CONTACT_TOPICS = ['General question', 'Wholesale and stockists', 'Press and collaborations', 'Something else'] as const

export const NAV_LINKS: SiteLink[] = [
    { label: 'Shop', href: '/shop' },
    { label: 'Hands', href: '/hands' },
    { label: 'How it works', href: '/how-it-works' },
    { label: 'About', href: '/about' }
]

export const FOOTER_COLUMNS: FooterColumn[] = [
    {
        title: 'Explore',
        links: [
            { label: 'Shop', href: '/shop' },
            { label: 'Hands', href: '/hands' },
            { label: 'How it works', href: '/how-it-works' },
            { label: 'Stories', href: '/#stories' }
        ]
    },
    {
        title: 'Company',
        links: [
            { label: 'About', href: '/about' },
            { label: 'Contact', href: '/about#contact' },
            { label: 'Terms', href: '/terms' }
        ]
    },
    {
        title: 'For stores',
        links: [
            { label: 'Wholesale', href: 'mailto:hello@softly.studio?subject=Wholesale%20enquiry' },
            { label: 'Ingredients', href: '/how-it-works#ingredients' },
            { label: 'Shipping', href: 'mailto:hello@softly.studio?subject=Shipping%20question' }
        ]
    }
]
